import { Component, EnvironmentInjector } from '@angular/core';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { Platform, Config, ToastController } from '@ionic/angular';
import { SettingsProvider } from '../providers/settings/settings';
import { ConfigProvider } from '../providers/config/config';
import { AdsProvider } from '../providers/ads/ads';
import { NotificationProvider } from '../providers/notification/notification';
import { UserProvider } from '../providers/user/user';
import { Storage } from '@ionic/storage';
import { TutorialProvider } from '../providers/tutorial/tutorial';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { DeeplinkProvider } from '../providers/deeplink/deeplink';
import { ResultProvider } from '../providers/result/result';
import { NewsController } from '../providers/news/news-contoller';
import { StorageProvider } from '../providers/storage-service/storage-service';
import { NewsProvider } from '../providers/news/news';
import { SessionProvider } from '../providers/session/session';
import { EventDetailsProvider } from '../providers/event-details/event-details';
import { AppDetectorProvider } from '../providers/detector/detector';
import { timer } from 'rxjs';
import { ScreenRotatableService } from '../providers/screen-rotatable/screen-rotatable.service';
import { PaymentService } from '../providers/payment.service';
import { EventProvider } from '../providers/event/event';
import { DarkMode, ThemeMode } from '../providers/dark-mode/dark-mode';
import { Router } from '@angular/router';
import { EventDetailsResolver } from 'src/pages/event/details/event-details/event-details-resolver';
import { TournamentService } from 'src/pages/apps/gamer/services/tournament.service';
import { LineUpService } from 'src/pages/apps/lineup/services/lineup-service';
import { WelcomeRestylePage } from 'src/pages/welcome/welcome-restyle/welcome-restyle';
import { EventSearchPage } from 'src/pages/event/main/event-search/event-search';
import { TabsPage } from 'src/pages/tabs/tabs';
import { NavigationService } from 'src/providers/navigation/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  templateUrl: 'app.component.html',
  selector: 'my-app',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  rootPage: any;
  welcomePage: boolean = false;
  tabNews: boolean = false;
  isBrowser: boolean = false;
  isSponsorbar: boolean = false;
  appIsOnDevice: boolean = false;
  appName: string = "";
  adType: string;
  private toast = null;
  dataSent = false;

  sponsors = null;
  activeSponsor = 0;
  isPremium: boolean = false;
  isAppReady = false;
  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public translateService: TranslateService,
    private settingsService: SettingsProvider,
    private config: Config,
    private router: Router,
    private conf: ConfigProvider,
    private toastCtrl: ToastController,
    public ads: AdsProvider,
    private userProvider: UserProvider,
    private deeplinks: Deeplinks,
    private deeplinkService: DeeplinkProvider,
    private tutorialProvider: TutorialProvider,
    private storage: Storage,
    private resultProvider: ResultProvider,
    private storageService: StorageProvider,
    private newsService: NewsProvider,
    private sessionService: SessionProvider,
    private screen: ScreenRotatableService,

    private eventDetailsResolver: EventDetailsResolver,
    private gs: TournamentService,
    private ls: LineUpService,

    private eventService: EventProvider,
    private paymentService: PaymentService,
    private appDetector: AppDetectorProvider,
    private darkModeService: DarkMode,
    private notificationService: NotificationProvider,
    public environmentInjector: EnvironmentInjector,
    private navigationService: NavigationService
  ) {
    console.log('appComponent', environment)
    // splashScreen.hide()
    this.platform.ready().then(async () => {
      await this.storageService.create()
      console.log('lang from storage',await  this.storageService._storage.get("selectedLanguage"));

      let lang = await this.settingsService.getActiveLanguage();
      let defaultLang = this.translateService.getDefaultLang();
      console.log('this.translateService.getDefaultLang()', defaultLang)
      console.log('await this.settingsService.getActiveLanguage()', lang)

      await this.unregisterServiceWorkersOnMobile();
      if ((platform.is('pwa')|| platform.is('desktop') || platform.is('mobileweb'))&& this.shouldAskForNotifications() ) {
        this.showNotificationToast();
      }


      if (!appDetector.isEventsApp()) this.ads.initAds();
      this.userProvider.init();
      this.initSubscriptions();
      await this.subscribeForNotificationToken();
      this.screen.lockPortraitOrientation();
      this.userProvider.init();
      this.adType = (await this.conf.config).ads.type;
      this.isBrowser = (await this.conf.config).platform.browser;
      this.appName = (await this.conf.config).appId;
      this.tabNews = (await this.conf.config).showHide.tabsNews;
      this.isSponsorbar = (await this.conf.config).ads.type === 'sponsor';
      this.isPremium = Boolean(JSON.parse(localStorage.getItem('premium'))) || false;
      this.appIsOnDevice = !this.isBrowser || (!this.platform.url().startsWith('https') || window.matchMedia('(display-mode: standalone)').matches);

      if (!this.appDetector.isHellaApp()) {
        await this.settingsService.enableAutoLocalization();
      }
      // change
      // this.config.set('swipeBackEnabled', true);

      setTimeout(() => {
        if (this.isPremium && !appDetector.isEventsApp()) this.ads.hide();
        splashScreen.hide();
      }, 1000);

      // this.fakeCall();
      this.ads.getSponsorAds().then(r => {
        this.sponsors = r;
        this.sponsorAds();
      });


      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      // statusBar.styleDefault();
      // statusBar.overlaysWebView(false);
      // menuCtrl.toggle();

      if ((await this.conf.config).showHide.welcomePage) {
        this.welcomePage = (await this.conf.config).showHide.welcomePage;
      }

      NewsController.getInstance().setServices(this.storageService, this.newsService, this.sessionService, this.userProvider, this.appName)

      this.translateService.get('GLOBAL_LOADING').subscribe(async (load) => {
        document.querySelector<HTMLInputElement>('.splash').className += ' fade';

        // COMMENT AFTER UPLOAD TO NGNIX
        // this.rootPage = TabsPage;

        // TEMPORARY FIX: BROWSER

        await this.preloadEventsWithRoutes();

        // UNCOMMENT THE CODE BELOW AFTER UPLOAD TO NGINX
        if (this.welcomePage) {
          await this.tutorialProvider.isFirstRun().then(status => {
            console.log('tutorial status ', status)
            if (status && !this.isBrowser) {
              this.rootPage = WelcomeRestylePage;
              this.tutorialProvider.setTutorialDone();
            } else {

              if (this.isBrowser || this.appDetector.isEventsApp()) {
                this.rootPage = EventSearchPage;
              } else {
                this.rootPage = TabsPage;
              }
              // this.deeplinkService.getOperation("thurnauergebnisse");

            }
          });
        } else {
          if (this.isBrowser || this.appDetector.isEventsApp()) {
            this.rootPage = EventSearchPage;
          } else {
            this.rootPage = TabsPage;
          }
          // this.deeplinkService.getOperation("thurnauergebnisse");
          this.tutorialProvider.setTutorialDone();
        }
        if (!this.appDetector.isSpooortsApp() && !this.appDetector.isTournamentApp() && !this.appDetector.isLeaderBoardApp()) this.showLocationMessage();
        this.startFailoverCheck();

        this.storageService._storage.get('resultVirtual').then((val) => {
          if (val) {
            if (!navigator.onLine) {
              window.addEventListener('online', () => {
                if (!this.dataSent) {
                  //alert('we are offline and there is data to send!');
                  this.resultProvider.sendVirtualResults(val).then(() => {
                    alert('we are online and there is data to send!');
                    this.storageService._storage.remove('resultVirtual');
                    this.dataSent = true;
                  });
                }
              });
            } else {
              //alert('we are online and there is data to send!');
              this.resultProvider.sendVirtualResults(val).then(() => {
                alert('we are online and there is data to send!');
                this.storageService._storage.remove('resultVirtual');
                this.dataSent = true;
              });
            }
          }
        });

        if (!this.appIsOnDevice) {
          // the app is in PWA mode, we proceed to detect device and browser support:
          let userAgent = navigator.userAgent;
          if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i)) {
            //code for "add to desktop" for iOS:
            this.translateService.get('ADDTOHOME_IOS').subscribe(addToHomeI => {
              this.presentToast(addToHomeI, 'bottom', 'speech-bubble-ios');
            });
          }
        }

        // Overwrite GLOBAL_LOADING on the start
        let elem = document.querySelector('div.loading-content');
        if (elem) {
          this.translateService.get(elem.innerHTML).subscribe(ldText => {
            if (elem) elem.innerHTML = ldText;
          });
        }
      });
      statusBar.styleDefault();

      //TEST DEEPLINK
      //https://m.spooorts.de/#/events?id=18879332 
      //https://m.spooorts.de/#/thurnauergebnisse
      //https://m.spooorts.de/#/paypal?amount=1&currency=USD&id=-1&token=asdasdasdasd
      //https://m.spooorts.de/#/savepayment?id=1&token=asdasdasdasd

      //https://m.gofo.rest/#/events?id=18879332 
      //https://m.gofo.rest/#/payment?amount=1&id=asdasdasdasd
      //https://m.gofo.rest/#/success_transaction?token=AAA&evId=1232&count=1&amount=12.50&firstName=slavik&lastName=spasibo&mail=test@gmail.com
      //https://m.gofo.rest/#/secondlayer?enaOrig=We%20Love%20Paris%20Digital%20Run
      //https://m.gofo.rest/#/language?lang=en

      // setTimeout(async() => {
      this.platform.ready().then(async()=>{
        await this.paymentService.checkPaymentStatus();
        if(platform.is('ios')&&!platform.is('pwa')){
          (window as any).handleOpenURL = (url: string) => {
            console.log('Deep link received', url);
            const deeplinkUrl = url;
            if(deeplinkUrl.includes('oauth/callback')){
              this.handleOAuthCallback(url)
            }else{
              this.deeplinkService.handleUrl(url);
            }
          };
        }else{
          this.deeplinks.route({
            '/test': {},
            '/callback':{}
          }).subscribe((match) => {
            console.log('Deeplink match:', JSON.stringify(match));
            if (match.$link && match.$link.path === '/callback' && match.$args && match.$args.code) {
              this.handleOAuthCallback(match.$link?.url)
            } else {
              this.deeplinkService.handleUrl(match.$link?.url || '');
            }
          }, (noMatch) => {
            console.log('noMatch: ' + JSON.stringify(noMatch));
            this.deeplinkService.handleUrl(noMatch);
          });
        }
      })
      
      // }, 0);
      this.isAppReady = true;
    });
  }
  handleOAuthCallback(url: string) {
    if (!url.includes('oauth/callback')) return;

    const normalized = url.replace('spooorts://', 'http://');
    const parsed = new URL(normalized);

    let code = parsed.searchParams.get('code');
    if (!code) return;

    code = code.replace(/#.*/, '');
    this.router.navigate(['/auth/callback'], {
      queryParams: {
        code,
        redirect_uri: 'spooorts://oauth/callback'
      }
    });
  }

  ngOnInit() {
    let mode = JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
    this.darkModeService.setThemeMode(mode);
    console.log('mode', mode)
    console.log(mode == ThemeMode.DarkMode)
    if (mode == ThemeMode.DarkMode) {
      document.querySelector('body').classList.add('darkMode')
    }
  }

  private async unregisterServiceWorkersOnMobile() {
    console.log('this.platform.is(android) ', this.platform.is('android'))
    console.log('this.platform.is(pwa)', this.platform.is('pwa'))
    if ((this.platform.is('android') || this.platform.is('ios'))&& !this.platform.is('mobileweb') && !this.platform.is('desktop') && !this.platform.is('pwa')) {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) {
          await reg.unregister();
          console.log('Service worker unregistered on mobile device');
        }
      }
    }
  }
  shouldAskForNotifications(): boolean {
    if (typeof Notification === 'undefined') return false;

    return Notification.permission === 'default' || Notification.permission === 'denied';
  }
  async showNotificationToast() {
    let message = ""
    this.translateService.get("ENABLE_PUSH_MESSAGE").subscribe(msg=>message = msg);
    const toast = await this.toastCtrl.create({
      message: message,
      position: 'top',
      cssClass: 'speech-bubble-ios',
      buttons: [
        {
          text: this.translateService.instant("GLOBAL_YES"),
          handler: async () => {
            await this.enableNotifications();
          }
        },
        {
          text: this.translateService.instant("GLOBAL_NO"),
          role: 'cancel'
        }
      ],
      duration: 1000000
    });
    await toast.present();
  }
  async enableNotifications() {
    try {
      await Notification.requestPermission();
    } catch (err) {
      console.error('Permission error', err);
    }
  }


  sponsorAds() {
    if (!this.sponsors) return;
    timer(0, 9900).subscribe(async () => {
      this.activeSponsor = (this.activeSponsor + 1) % this.sponsors.length;
    });
  }

  showLocationMessage() {
    this.tutorialProvider.isFirstRun().then((status) => {
      if (status) {
        let app = "";

        if (this.appName.includes('hella')) {
          app = "Laufgesellschaft";
        } else if (this.appName.includes('postbonn')) {
          app = "Deutsche Post Marathon Bonn";
        } else if (this.appName.includes('vivawest')) {
          app = "VIVAWEST-Marathon";
        } else if (this.appName.includes('gesunder')) {
          app = "Gesunder Hafen";
        } else if (this.appName.includes('thurnau')) {
          app = "Thurnau Läuft";
        } else if (this.appName.includes('hannover')) {
          app = "Hannover Marathon";
        } else if (this.appName.includes('leaderboard')) {
          app = "Leaderboard";
        } else {
          app = "GOForest";
        }

        if (!this.isBrowser)
          this.presentToast(this.translateService.instant("START_PERMISSION_MESSAGE", { name: app }), "bottom", "speech-bubble-ios");
      }
    });
  }

  async preloadEventsWithRoutes() {
    if (!this.appDetector.isEventsApp()) {
      let lid = (await this.conf.config)?.client?.lid + '';

      this.eventDetailsResolver.preloadMap(lid).then((events) => {
        EventDetailsProvider.getInstance().setEvents(events);
      });
    }
  }

  async presentToast(message, position, cssclass) {
    // prevent toasts from "stacking":
    if (this.toast) {
      await this.toast.dismiss();
      this.toast = null;
    }
    // create a toast:
    this.toast = await this.toastCtrl.create({
      message: message,
      buttons: [{ text: 'OK', role: 'cancel' }],
      cssClass: cssclass,
      position: position,
      duration: 10000
    });
    await this.toast.present();
  }



  startFailoverCheck() {
    let that = this;
    setInterval(() => {
      this.isSiteOnline(`${environment.spooortsWebApp}resources/images/spooorts_logo_beta.svg`, function (online) {
        if (online) {
          that.conf.switchToInitialUrl();
          console.log('switched to initial https://spooorts.de/');
        } else {
          console.log('offline https://spooorts.de/');
        }
      });
    }, 20000);
  }

  isSiteOnline(url, callback) {
    // try to load favicon
    var timer = setTimeout(function () {
      // timeout after 1.7 seconds
      callback(false);
    }, 1700)

    var img = document.createElement("img");
    img.onload = function () {
      clearTimeout(timer);
      callback(true);
    }

    img.onerror = function () {
      clearTimeout(timer);
      callback(false);
    }

    img.src = url;
  }

  initSubscriptions() {
    if (!this.appDetector.isEventsApp()) {
      this.sessionService.requestLoggedIn.subscribe(() => {
        setTimeout(() => {
          if (!this.sessionService.profile.premium) {
            this.ads.show();
          } else {
            this.ads.hide();
          }
        }, 1000);
        localStorage.setItem('premium', JSON.stringify(this.sessionService.profile.premium));
      });
      this.sessionService.requestLogout.subscribe(() => {
        localStorage.removeItem("premium");
        // height: calc(100 % - 50px)!important;
        if (!this.isPremium) this.ads.show();
        localStorage.setItem('premium', JSON.stringify(false));
      });
    }
  }

  async subscribeForNotificationToken() {
    console.log('Registering notifications via NotificationProvider');
    try {
      this.notificationService.onRecive().subscribe(async(notification) => {
        console.log('Notification received in AppComponent:', JSON.stringify(notification));        
        await this.presentNotiToast(
          notification.aps?.alert.title || notification.title,
          notification.aps?.alert.body || notification.body,
          'top',
          'push-noti',
          notification
        );
      });

      this.notificationService.onRegistration().subscribe(async(resToken)=>{
        console.log('resToken', resToken)
        if(resToken) await this.userProvider.checkLoged(resToken);
      });
      const token = await this.notificationService.getNotificationToken();
      if (token) {
        console.log('Firebase token available:', token);
        await this.userProvider.checkLoged(token);
      }

    } catch (error) {
      console.error('Error registering notifications:', error);
    }
  }
  async presentNotiToast(title:string,message:string, position:"top" | "bottom" | "middle", cssclass:string, notification:any) {
    if (this.toast) {
      await this.toast.dismiss();
      this.toast = null;
    }
    this.toast = await this.toastCtrl.create({
      header:title,
      message: message,
      icon:'events',
      cssClass: cssclass,
      position: position,
      duration: 10000,
    });
    this.toast.addEventListener('click', () => {
      console.log('Toast clicked');
      if (notification) {
        this.notificationService.handleNotification(notification);
      }
      this.toast.dismiss();
    });
    await this.toast.present();
  }
}